<!DOCTYPE html>
<div class="lotteries-wrapper" *ngIf="loaded; else loading">
    <ng-container *ngIf="socialFortuneDiscoverPromises$ | async as lottery else loading">
        <div class="lotteries-bigcard-wrapper">
            <div class="titles-block">
                <h2>{{"discovery.fGroup" | translate}}</h2>
                <p>{{"discovery.fPopular" | translate}}</p>
            </div>
            <div class="big-slider-block">
                <div class="empty-state" *ngIf="">
                    <div>{{"discovery.fnoData_yet" | translate}}</div>
                </div>
                <swiper [config]="big_discoverSliderOptions" class="swiper-inbox">
                    <ng-template swiperSlide
                        *ngFor="let data of (lottery?.top | filterYoursToPlay : 1) ; let i = index">
                        <ion-grid *ngFor="let lottery of data">
                            <div class="lottery-card powerball" [style.background]="lottery?.lotteryData?.background">
                                <ion-row class="player-card">
                                    <ion-col class="left-block">
                                        <div class="title">{{lottery?.lotteryData?.real_name}}</div>
                                        <div class="img">
                                            <img src="{{lottery?.lotteryData?.image_url}}" alt="">
                                        </div>
                                    </ion-col>
                                    <ion-col class="right-block">
                                        <span class="timer">
                                            <img src="../../../../../assets/icon/clock.svg" alt="">
                                            <app-count-down-timer class="remaining-time"
                                                end="{{lottery?.lotteryData?.expiry_date?.seconds}}" type="seconds">
                                            </app-count-down-timer>
                                        </span>
                                        <div>
                                            <h3>
                                                {{currencySymbol}}
                                                {{lottery?.lotteryData?.jackpot_value}}
                                                <span *ngIf="lottery?.lotteryData?.featured" class="fire-icon">🔥</span>
                                            </h3>
                                            <button
                                                (click)="showJackpotDetails(lottery?.lotteryData?.real_name)">{{"discovery.Playnow"
                                                | translate}}</button>
                                        </div>
                                    </ion-col>
                                </ion-row>
                            </div>
                        </ion-grid>
                    </ng-template>

                </swiper>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="socalFortueDiscoveryFriendsPromises$ | async as lottery else loading">
        <div class="lotteries-smallcard-wrapper padding-for-text">

            <div class="titles-block">
                <h2>{{"discovery.friendsLotteries" | translate}}</h2>
                <p>{{"discovery.friendsTry" | translate}}</p>
            </div>
            <ng-container *ngIf="!lottery || !lottery?.friends || !lottery?.friends.length; else showFriend">
                <ion-card class="trending-card">

                    <div class="img-wrraper">
                        <img src="../../../../assets/icon/img-icon.svg" alt="" />
                        <span class="group-link">{{ "discovery.Make" | translate }} <a (click)="openCommnuityTab()"> {{
                                "discovery.Group" |
                                translate
                                }}</a></span>
                    </div>
                </ion-card>
            </ng-container>
            <ng-template #showFriend>
                <div class="small-slider-block">
                    <swiper [config]="discoverSliderOptions" class="swiper-inbox">
                        <!-- <ng-template swiperSlide class="slide"> -->
                        <ng-template swiperSlide
                            *ngFor="let data of (lottery?.friends | filterYoursToPlay : 2) ; let i = index">

                            <div class="lottery-cards">
                                <ion-grid *ngFor="let lottery of data">
                                    <ion-row class="card top-card loto"
                                        [style.background]="lottery?.friends?.background">
                                        <ion-col class="left-block" size="5">
                                            <div class="img">
                                                <img src="{{lottery?.friends?.image_url}}" alt="">
                                            </div>
                                        </ion-col>
                                        <ion-col class="right-block" size="7">
                                            <span class="timer">
                                                <img src="../../../../../assets/icon/clock.svg" alt="">

                                                <app-count-down-timer class="remaining-time"
                                                    end="{{lottery?.friends?.expiry_date?.seconds}}" type="seconds">
                                                </app-count-down-timer>
                                            </span>
                                            <div>
                                                <h5 class="title">{{lottery?.friends?.real_name}}</h5>
                                                <h3>
                                                    {{currencySymbol}}
                                                    {{lottery?.friends?.jackpot_value}}
                                                    <span *ngIf="lottery?.friends?.featured" class="fire-icon">🔥</span>
                                                </h3>
                                            </div>
                                            <span (click)="showJackpotDetails(lottery?.friends?.real_name)"><img
                                                    src="../../../../../assets/icon/subtract.svg"></span>
                                        </ion-col>
                                    </ion-row>
                                    <hr />

                                </ion-grid>
                            </div>
                        </ng-template>

                    </swiper>
                </div>
            </ng-template>
        </div>
    </ng-container>
    <div class="lotteries-smallcard-wrapper">
        <ng-container *ngIf="socialFortuneDiscoverPromises$ | async as lottery  else loading ">
            <div class="titles-block">
                <h2>{{"discovery.fWhy_not" | translate}}</h2>
                <p>{{"discovery.fteam_should_try" | translate}}</p>
            </div>
            <div class="small-slider-block">
                <swiper [config]="discoverSliderOptions" class="swiper-inbox">
                    <!-- <ng-template swiperSlide class="slide"> -->
                    <ng-template swiperSlide
                        *ngFor="let data of (lottery?.try | filterYoursToPlay : 2) ; let i = index">
                        <div class="lottery-cards" *ngFor="let lottery of data">
                            <ion-grid>
                                <ion-row class="card bottom-card laprimitiva"
                                    [style.background]="lottery?.lotteryData?.background">
                                    <ion-col class="left-block" size="5">
                                        <div class="img">
                                            <img src="{{lottery?.lotteryData?.image_url_small}}" alt="">
                                        </div>
                                    </ion-col>
                                    <ion-col class="right-block" size="7">
                                        <span class="timer">
                                            <img src="../../../../../assets/icon/clock.svg" alt="">
                                            <app-count-down-timer class="remaining-time"
                                                end="{{lottery?.lotteryData?.expiry_date?.seconds}}" type="seconds">
                                            </app-count-down-timer>
                                        </span>
                                        <div>
                                            <h5 class="title">{{lottery?.lotteryData?.real_name}}</h5>
                                            <h3>
                                                {{currencySymbol}}
                                                {{lottery?.lotteryData?.jackpot_value}}
                                                <span *ngIf="lottery?.lotteryData?.featured" class="fire-icon">🔥</span>
                                            </h3>
                                        </div>
                                    </ion-col>
                                    <span (click)="showJackpotDetails(lottery?.lotteryData?.real_name)"><img
                                            src="../../../../../assets/icon/subtract.svg"></span>
                                </ion-row>
                                <hr />


                            </ion-grid>
                        </div>
                    </ng-template>
                </swiper>
            </div>
        </ng-container>
    </div>
</div>
<ng-template #loading>
    <app-in-progress-animation type="lotteries-cards-skeleton"></app-in-progress-animation>
</ng-template>